<!-- =========================================
     PREMIUM TOYS HERO BANNER — Enhanced UI/UX
========================================= -->

<div class="toys-hero-banner">
    <owl-carousel-o [options]="homeSlidesOptions">

        <ng-template carouselSlide *ngFor="let content of mainBannerItem; let i = index">

            <section class="toy-slide">

                <!-- Animated Background -->
                <div class="bg-layer" [ngStyle]="{'background-image': 'url(' + content.image + ')'}"></div>
                <div class="mesh-gradient"></div>

                <!-- Floating Toys (decorative, aria-hidden) -->
                <div class="floating-toys" aria-hidden="true">
                    <div class="toy toy-bear">🧸</div>
                    <div class="toy toy-rocket">🚀</div>
                    <div class="toy toy-cube">🧩</div>
                    <div class="toy toy-ball">⚽</div>
                    <div class="toy toy-star">⭐</div>
                </div>

                <!-- Glass Orbs (decorative) -->
                <div class="glass-orb orb1" aria-hidden="true"></div>
                <div class="glass-orb orb2" aria-hidden="true"></div>

                <!-- Slide Progress Indicator -->
                <!-- <div class="slide-progress" aria-hidden="true">
                    <div class="progress-bar"></div>
                </div> -->

                <div class="container-fluid">
                    <div class="row align-items-center min-vh-100">

                        <!-- LEFT CONTENT -->
                        <div class="col-lg-6">
                            <div class="hero-content">

                                <!-- <div class="premium-tag">
                                    <span class="tag-dot" aria-hidden="true"></span>
                                    {{ content.tagline }}
                                </div> -->

                                <h1 class="hero-title">
                                    {{ content.title }}
                                    <span class="title-accent">{{ content.title2 }}</span>
                                </h1>

                                <p class="hero-text">{{ content.paragraph }}</p>

                                <div class="hero-buttons">
                                    <a class="btn hero-btn primary-btn" routerLink="/menu" role="button">
                                        <span class="btn-icon" aria-hidden="true">🛍️</span>
                                        Shop Collection
                                        <span class="btn-arrow" aria-hidden="true">→</span>
                                    </a>
                                    <a class="btn hero-btn secondary-btn" routerLink="/about" role="button">
                                        More About Us
                                    </a>
                                </div>

                                <!-- FEATURES -->
                                <div class="hero-features" role="list">

                                    <div class="feature-box" role="listitem">
                                        <div class="feature-icon-wrap" aria-hidden="true"  [style.background-image]="'url(assets/img/toy_icons/icon_1.png)'">
                                            <!-- <span class="feature-icon">🎨</span> -->
                                            <!-- <img src="../assets/img/toy_icons/icon_1.png" alt=""> -->
                                        </div>
                                        <div class="feature-text">
                                            <strong>Creative Play</strong>
                                            <small>Imagination first</small>
                                        </div>
                                    </div>

                                    <div class="feature-box" role="listitem" >
                                        <div class="feature-icon-wrap" aria-hidden="true" [style.background-image]="'url(assets/img/toy_icons/icon_2.png)'">
                                            <!-- <span class="feature-icon">🛡️</span> -->
                                        </div>
                                        <div class="feature-text">
                                            <strong>Child Safe</strong>
                                            <small>Tested & certified</small>
                                        </div>
                                    </div>

                                    <div class="feature-box" role="listitem">
                                        <div class="feature-icon-wrap" aria-hidden="true" [style.background-image]="'url(assets/img/toy_icons/icon_3.png)'">
                                            <!-- <span class="feature-icon">🚚</span> -->
                                        </div>
                                        <div class="feature-text">
                                            <strong>Fast Delivery</strong>
                                            <small>To your door</small>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <!-- RIGHT VISUAL -->
                        <div class="col-lg-6">
                            <div class="hero-visual d-none" aria-hidden="true">

                                <!-- Outer ring glow -->
                                <div class="ring-glow ring-glow--outer"></div>
                                <div class="ring-glow ring-glow--inner"></div>

                                <!-- Main Showcase Platform -->
                                <div class="showcase-platform">

                                    <div class="platform-shine"></div>

                                    <!-- <img src="assets/img/toys/robot.png"
                                         class="main-toy robot"
                                         alt=""
                                         loading="eager">

                                    <img src="assets/img/toys/train.png"
                                         class="main-toy train"
                                         alt=""
                                         loading="eager"> -->

                                    <!-- Sparkles inside platform -->
                                    <span class="sparkle sp1" aria-hidden="true">✦</span>
                                    <span class="sparkle sp2" aria-hidden="true">✦</span>
                                    <span class="sparkle sp3" aria-hidden="true">✧</span>

                                </div>

                                <!-- Floating Badge Cards -->
                                <div class="floating-card card1">
                                    <span class="card-icon">📚</span>
                                    <span>Educational Toys</span>
                                </div>

                                <div class="floating-card card2">
                                    <span class="card-icon">⭐</span>
                                    <span>Premium Quality</span>
                                </div>

                                <div class="floating-card card3">
                                    <span class="card-icon">🔥</span>
                                    <span>Best Seller</span>
                                </div>

                                <!-- Rating badge -->
                                <div class="rating-badge">
                                    <span class="rating-stars">★★★★★</span>
                                    <span class="rating-text">4.9 / 5 &nbsp;· &nbsp;2k+ Reviews</span>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </section>

        </ng-template>

    </owl-carousel-o>
</div>